import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { useProfileContext } from 'hooks/context/useProfileContext'
import { DetailsRow } from './DetailsRow'

export const PersonalDetails = () => {
  const { t } = useTranslation()

  const { profile } = useProfileContext() || {}
  const { firstName, lastName, country, emailAddress } = profile || {}

  return (
    <Box flexCol gapY={24}>
      <Box tag="h2" className="text-lg font-semibold text-gray-900">
        {t('account.personalDetails')}
      </Box>
      <Box flexCol gapY={16}>
        <DetailsRow label={t('firstName')}>{firstName || '-'}</DetailsRow>
        <DetailsRow label={t('lastName')}>{lastName || '-'}</DetailsRow>
        <DetailsRow label={t('country')}>{country?.name || '-'}</DetailsRow>
        <DetailsRow label={t('emailAddress')}>{emailAddress || '-'}</DetailsRow>
      </Box>
    </Box>
  )
}
